export class ResourceTypeCondition {
    'operator';
    'resourceTypes';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResourceTypeCondition.attributeTypeMap;
    }
    constructor() {
    }
}
